import type React from 'react'

import type { OptionsWithoutGroup } from '../../types'
import { Option } from '../Option'

type Props = {
  options: OptionsWithoutGroup
  selectedValue?: string | number
  onClick: (value: string | number) => void
  children?: React.ReactNode
}

const OptGroup: React.FC<Props> = ({ options, selectedValue, onClick }) => {
  return (
    <div>
      {options.map((option, key) => (
        <Option
          {...option}
          key={key}
          onClick={onClick}
          selected={option.value === selectedValue}
        >
          {option.label}
        </Option>
      ))}
    </div>
  )
}

export default OptGroup
